import type { UseAnalyticsOptions } from '~/composables/analytics/useAnalytics'
import type { ProposalStartedEventPayload } from '~/types/analytics'
import { useAnalytics } from '~/composables/analytics/useAnalytics'

export function useTrackProposalStarted(options: UseAnalyticsOptions = {}) {
  const { trackEvent } = useAnalytics(options)

  function trackProposalStarted(payload: ProposalStartedEventPayload) {
    trackEvent('proposal_started', { ...payload })
  }

  return { trackProposalStarted }
}
